export const userInfoGetters = {
  getUserInfo(state, getters) {
    return state.userinfo;
  },
  getErrMsg(state, getters){
    return state.errMsg;
  } 
};



// WEBPACK FOOTER //
// ./src/store/getters.js